import dayjs from "dayjs";

import { patientIdFromReference } from "../aggregations";

/**
 * Extrai a data ISO (YYYY-MM-DD) do início do Appointment para comparação de filtros.
 * Usa dayjs para normalizar timezone do servidor FHIR.
 */
function appointmentStartToIsoDate(start: string | undefined): string | null {
  if (!start?.trim()) return null;
  const parsed = dayjs(start);
  if (!parsed.isValid()) return null;
  return parsed.format("YYYY-MM-DD");
}

/**
 * A partir de um Bundle de Appointment, monta mapa patientId → data da consulta
 * mais recente (maior `start`) entre os recursos retornados.
 */
export function deriveLastAppointmentByPatientId(
  bundle: fhir5.Bundle | undefined,
): Map<string, string> {
  const map = new Map<string, string>();

  for (const entry of bundle?.entry ?? []) {
    const resource = entry.resource;
    if (!resource || resource.resourceType !== "Appointment") continue;

    const appointment = resource as fhir5.Appointment;
    const isoDate = appointmentStartToIsoDate(appointment.start);
    if (!isoDate) continue;

    const patientRef = appointment.participant?.find((p) =>
      p.actor?.reference?.startsWith("Patient/"),
    )?.actor?.reference;

    const patientId = patientRef ? patientIdFromReference(patientRef) : undefined;
    if (!patientId) continue;

    const existing = map.get(patientId);
    if (!existing || isoDate > existing) {
      map.set(patientId, isoDate);
    }
  }

  return map;
}
